// Utility Functions

// Generate unique ID
function generateUID() {
    return 'USR_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

// Store user session
function setUserSession(userData) {
    localStorage.setItem('act_user', JSON.stringify(userData));
}

// Get user session
function getUserSession() {
    const userData = localStorage.getItem('act_user');
    return userData ? JSON.parse(userData) : null;
}

// Clear user session
function clearUserSession() {
    localStorage.removeItem('act_user');
}

// Check if user is logged in
function isLoggedIn() {
    return getUserSession() !== null;
}

// Redirect if not logged in
function requireAuth() {
    if (!isLoggedIn()) {
        window.location.href = '/pages/act-login';
    }
}

// Format date
function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

// Show loading spinner
function showLoading(message = 'Loading...') {
    const loader = document.getElementById('loading');
    if (loader) {
        loader.querySelector('.loading-text').textContent = message;
        loader.style.display = 'flex';
    }
}

// Hide loading spinner
function hideLoading() {
    const loader = document.getElementById('loading');
    if (loader) {
        loader.style.display = 'none';
    }
}

// Enhanced showMessage function with better styling
function showMessage(message, type = 'info') {
    // Remove any existing messages
    const existingMessages = document.querySelectorAll('.message-toast');
    existingMessages.forEach(msg => msg.remove());
    
    // Create message element
    const messageDiv = document.createElement('div');
    messageDiv.className = `message-toast message-${type}`;
    
    // Set background colors based on type
    const colors = {
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6'
    };
    
    const icons = {
        success: '✓',
        error: '✕',
        warning: '⚠',
        info: 'ℹ'
    };
    
    messageDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background-color: ${colors[type] || colors.info};
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 14px;
        font-weight: 500;
        max-width: 400px;
        animation: slideInRight 0.3s ease-out;
        display: flex;
        align-items: center;
        gap: 10px;
    `;
    
    // Add icon
    const iconSpan = document.createElement('span');
    iconSpan.textContent = icons[type] || icons.info;
    iconSpan.style.cssText = `
        font-size: 18px;
        font-weight: bold;
    `;
    
    // Add message text
    const textSpan = document.createElement('span');
    textSpan.textContent = message;
    
    messageDiv.appendChild(iconSpan);
    messageDiv.appendChild(textSpan);
    
    // Add animation
    const style = document.createElement('style');
    style.textContent = `
        @keyframes slideInRight {
            from {
                transform: translateX(400px);
                opacity: 0;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        }
        @keyframes slideOutRight {
            from {
                transform: translateX(0);
                opacity: 1;
            }
            to {
                transform: translateX(400px);
                opacity: 0;
            }
        }
    `;
    if (!document.querySelector('#message-animations')) {
        style.id = 'message-animations';
        document.head.appendChild(style);
    }
    
    document.body.appendChild(messageDiv);
    
    // Auto-remove after 4 seconds with animation
    setTimeout(() => {
        messageDiv.style.animation = 'slideOutRight 0.3s ease-out';
        setTimeout(() => {
            messageDiv.remove();
        }, 300);
    }, 4000);
    
    // Also display in messageContainer if it exists (for forms)
    const messageContainer = document.getElementById('messageContainer');
    if (messageContainer) {
        messageContainer.style.display = 'block';
        messageContainer.className = `alert alert-${type}`;
        messageContainer.style.cssText = `
            padding: 12px 16px;
            border-radius: 6px;
            margin-bottom: 15px;
            background-color: ${type === 'error' ? '#fee2e2' : type === 'success' ? '#d1fae5' : '#dbeafe'};
            color: ${type === 'error' ? '#991b1b' : type === 'success' ? '#065f46' : '#1e40af'};
            border: 1px solid ${type === 'error' ? '#fca5a5' : type === 'success' ? '#6ee7b7' : '#93c5fd'};
            font-size: 14px;
        `;
        messageContainer.textContent = message;
        
        // Auto-hide after 4 seconds
        setTimeout(() => {
            messageContainer.style.display = 'none';
        }, 4000);
    }
}

function getUserData() {
    return getUserSession();
}